<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// App logic here when needed
</script>
